import '../App.css';
import { useState, useEffect } from 'react';
import axios from '../apis/Axios';
import { SERVER_URL } from '../apis/Api';
import CrossfadeSlider from './CrossfadeSlider';

function ArtworkGallery(props) {
    const { isSlider, onAllImagesLoaded, onError } = props;
    const [images, setImages] = useState([]);

    useEffect(() => {
        const getImageData = async () => {          
            try { 
                const res = await axios.get('api/general/images');
                
                // preload all images 
                const imagePromises = res.data.map(img => {
                    return new Promise((resolve, reject) => {
                        const image = new Image();
                        image.onload = resolve;
                        image.onerror = reject;
                        image.src = SERVER_URL + img.url;
                    });
                });
                
                // wait for all images to load
                await Promise.all(imagePromises);
                
                // notify parent
                setImages(res.data);
                onAllImagesLoaded?.();
            } catch (err) {
                console.log(err);
                onError?.(err);
            }
        };
        
        getImageData();
    }, [onAllImagesLoaded, onError]);

    const pattern = ['tall', 'normal'];

    return (
        <div>
            {
                isSlider ?
                    <CrossfadeSlider images={ images } />
                : 
                    <div style={{ maxWidth: '100%', margin: '4vw auto', padding: '0 10px' }}>
                        <div className='artwork-gallery'>
                            <div className='gallery-grid'>
                                {   
                                    images.map((img, index) => {
                                        const variant = pattern[index % pattern.length];
                                        const className = variant === 'normal'
                                            ? 'gallery-item'
                                            : `gallery-item gallery-item-${variant}`;
                                        
                                        return (
                                            <div key={img.name} className={className}>
                                                <img
                                                    src={`${SERVER_URL + img.url}`}
                                                    alt=''
                                                    onError={(e) => console.log('Failed to load the image: ', e.target.src)}
                                                />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default ArtworkGallery;